import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    subscriptions: [],
    totalRows: 0,
    currentPage: 1,
    pageSize: 10,
    totalPages: 0,
    subscriptionDetails: null,
    loading: false,
    error: null,
};

const subscriptionSlice = createSlice({
    name: "subscription",
    initialState,
    reducers: {
        setLoading: (state, action) => {
            state.loading = action.payload;
        },
        setSubscriptions: (state, action) => {
            // ✅ SIMPLIFIED: Like contact reducer
            const responseData = action.payload?.data || [];
            state.subscriptions = Array.isArray(responseData) ? responseData : [];

            const pagination = action.payload?.pagination;
            state.totalRows =
                action.payload.totalData ||
                action.payload.totalSubscriptions ||
                pagination?.totalSubscriptions ||
                pagination?.totalItems ||
                state.subscriptions.length || 0;

            if (pagination) {
                state.currentPage = pagination.currentPage || 1;
                state.totalPages = pagination.totalPages || Math.ceil(state.totalRows / state.pageSize);
                if (pagination.itemsPerPage) {
                    state.pageSize = pagination.itemsPerPage;
                }
            } else {
                state.totalPages = Math.ceil(state.totalRows / state.pageSize);
            }
        },
        setSubscriptionDetails: (state, action) => {
            state.subscriptionDetails = action.payload;
        },
        clearSubscriptionDetails: (state) => {
            state.subscriptionDetails = null;
        },
        setError: (state, action) => {
            state.error = action.payload;
        },
        setPagination: (state, action) => {
            state.currentPage = action.payload.page || state.currentPage;
            state.pageSize = action.payload.pageSize || state.pageSize;
        },
    },
});

export const {
    setLoading,
    setSubscriptions,
    setSubscriptionDetails,
    clearSubscriptionDetails,
    setError,
    setPagination,
} = subscriptionSlice.actions;

export default subscriptionSlice.reducer;